// Tab constants for ResponseManagerV3 (matches CMP V1 API tabs)
export const RESPONSE_MANAGER_V3_TABS = {
  NEW: "NEW",
  VIEWED: "VIEWED",
  HIRED: "HIRED",
  REJECTED: "REJECTED"
} as const;

// Sub-tab constants for ResponseManagerV3
export const RESPONSE_MANAGER_V3_SUB_TABS = {
  DEFAULT: "default"
} as const;

// Export types
export type ResponseManagerV3TabId =
  (typeof RESPONSE_MANAGER_V3_TABS)[keyof typeof RESPONSE_MANAGER_V3_TABS];

export type ResponseManagerV3SubTabId =
  (typeof RESPONSE_MANAGER_V3_SUB_TABS)[keyof typeof RESPONSE_MANAGER_V3_SUB_TABS];

export const RESPONSE_MANAGER_V3 = "response_manager_v3";
